import { createElement } from 'react';
import styled from 'styled-components';
const Root = styled.div `
  /* @desc 为了给页面一个高度 以防遮住内容区 */
  height: ${(props) => (props.height ? `${props.height}px` : '56px')};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0;
  /* 解决 table 无数据时的透视问题 */
  z-index: 5;
  position: fixed;
  bottom: 0;
  right: 0;
  padding: 0 16px 0 24px;
  width: 100%;
  box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  /** @desc line 公共样式 */
  button,
  a {
    margin-left: 10px;
  }
`;
const FixedOpt = ({ height, style, children }) => {
    console.log('stye', style);
    return (createElement(Root, { height: height, style: style }, children));
};
FixedOpt.displayName = 'FixedOpt';
export default FixedOpt;
